import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import colors from 'styles/colors'
import { Tabs as TabsType } from 'types/enums/analytics/content/sort/Tabs'

interface IProps {
    tab: TabsType
    setTab: (value: TabsType) => void
}

export const AnalyticsContentModalSortTabs = ({ tab, setTab }: IProps) => {
    const { t } = useTranslation()

    const setActiveTab = (tab: TabsType) => {
        setTab(tab)
    }

    const tabMap = [
        { value: TabsType.SALES, name: t('sales') },
        { value: TabsType.ANALYTICS, name: t('analytics') },
        { value: TabsType.ENGAGEMENT, name: t('engagement') }
    ]

    return (
        <Container>
            {tabMap.map(({ value, name }) => (
                <TabOption
                    key={value}
                    $active={tab === value}
                    onClick={() => {
                        setActiveTab(value)
                    }}
                >
                    {name}
                </TabOption>
            ))}
        </Container>
    )
}

const Container = styled.div`
    display: flex;
    flex-grow: 1;
    flex-shrink: 0;
    align-items: center;
    background: ${() =>
        `linear-gradient(90deg, ${colors.whiteSmoke} 55.26%, #ededed 100%)`};
    height: 4rem;
    width: max-content;
    justify-content: start;
    padding: 0 0.5rem;
    margin: 0rem 0 1.5rem;
    border-radius: 2rem;
    gap: 0.5rem;
`

interface TabOptionProps {
    $active: boolean
}

const TabOption = styled.div<TabOptionProps>`
    font-weight: 600;
    font-size: 1.2rem;
    line-height: 1.5rem;
    letter-spacing: 0.04em;
    color: $grey;
    padding: 0.8rem 1rem;
    // transition: all ease-in-out 0.3s;
    border-radius: 2rem;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
    user-select: none;
    
    &:hover {
        ${props => !props.$active && `background: #dedfe3;`}
    }

    ${props =>
        props.$active &&
        `
        color: white;
        background: ${colors.slateBlue};
    `}
`
